import script from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTabs.vue?vue&type=style&index=0&id=32bef175&lang=css"
import "./MoleculeTabs.vue?vue&type=style&index=1&id=32bef175&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32bef175"]])

export default __exports__